var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHardwareIconPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 21.8001C23.949 21.8001 21.8 23.9491 21.8 26.6001C21.8 29.2511 23.949 31.4001 26.6 31.4001C29.251 31.4001 31.4 29.2511 31.4 26.6001C31.4 23.9491 29.251 21.8001 26.6 21.8001ZM26.6 21.8001V10.6001C26.6 9.75141 26.2629 8.93747 25.6627 8.33736C25.0626 7.73724 24.2487 7.4001 23.4 7.4001H18.6M7.39999 12.2001C10.051 12.2001 12.2 10.0511 12.2 7.4001C12.2 4.74913 10.051 2.6001 7.39999 2.6001C4.74902 2.6001 2.59999 4.74913 2.59999 7.4001C2.59999 10.0511 4.74902 12.2001 7.39999 12.2001ZM7.39999 12.2001V31.4001",
    stroke: "#F7F7F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardwareIconPlain);
export default __webpack_public_path__ + "static/media/Hardware-Icon-Plain.8cc957e5becb350e4dcd7d6dd336c1c8.svg";
export { ForwardRef as ReactComponent };